import { OrderDetail } from './OrderDetail.js'
import type { IOrder, ISamplePool } from 'Model/index.js'
import { getProcessingTypeAccentBg, getProcessingTypeAccentBorder } from '../../../Util/processingType.ts'
import { getProcessingTypeLabel } from '../../../Util/processingType.ts'
import { useGetAuthenticatedUser } from '../../../Flux/Selector/index.js'
import { useDispatch } from 'react-redux'
import Actions from '../../../Flux/index.js'
import { authenticationSlice } from '../../../Flux/Slice/Authentication/AuthenticationSlice.js'
import { useUserWasFetched } from '../../../Flux/Selector/Authentication/GetAuthenticatedUser/UserWasFetchedSelector.js'

interface IOrderDetailViewProps {
  order: IOrder
  samplePools: ISamplePool[] | 'LOADING'
  tokenChecksum?: string
  otuCount?: number
}

export function OrderDetailView(props: IOrderDetailViewProps) {
  const user = useGetAuthenticatedUser()
  const wasFetched = useUserWasFetched()
  const dispatch = useDispatch()

  if (!user && wasFetched) {
    dispatch(
      Actions[authenticationSlice.name].authenticationExpired({
        failedRequest: 'none',
        message: 'You are currently not logged in',
        showAlways: true
      })
    )
  }

  return (
    <div className={`relative overflow-hidden bg-slate-100 rounded-lg p-4 sm:p-6 md:p-8 h-fit drop-shadow-sm w-full max-w-6xl mx-auto ${getProcessingTypeAccentBorder(props.order.processingType)}`}>
      <span className={`absolute top-0 left-0 text-xs font-semibold text-white px-2.5 py-1 rounded-br-md ${getProcessingTypeAccentBg(props.order.processingType)}`}>
        {getProcessingTypeLabel(props.order.processingType)}
      </span>
      <OrderDetail order={props.order} samplePools={props.samplePools} tokenChecksum={props.tokenChecksum} otuCount={props.otuCount} />
    </div>
  )
}
